import React from 'react';
import { Icon } from '../Icon';
import styles from './PauseSlideContentV21.css';

function PauseSlideContentV21() {
    return (
        <section className={styles.form}>
            <h2 className={styles.heading}>Can’t remember? That’s where it starts.</h2>
            <div className={styles.card}>
                <div className={styles.people} aria-hidden='true'>
                    {Array.from({ length: 33 }, (_, index) => (
                        <Icon key={index} name='person' className={styles.person} />
                    ))}
                </div>
                <p className={styles.stat}>8 in 10</p>
                <p className={styles.statText}>people who told Boundly “I don’t remember” kept going, and the next question brought more back</p>
                <p className={styles.source}>Boundly chats, Aug–Oct 2026</p>
            </div>
            <p className={styles.description}>Boundly asks one question at a time, and each answer brings the next memory closer.</p>
        </section>
    );
}

export {
    PauseSlideContentV21
};
